import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Row, Col, Alert, Spinner, Modal, ListGroup } from 'react-bootstrap';
import Header from '../../layouts/Header';
import { useDropzone } from 'react-dropzone';
import axios from '../../api/axios';
import Select from 'react-select';
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import 'jspdf-autotable'
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { useSelector } from 'react-redux';
import makeAnimated from "react-select/animated";
import { useNavigate } from 'react-router-dom';

const ProductCostingReport = () => {

    const getInitialMenuPricingFilters = () => {
        const saved = sessionStorage.getItem('menuPricingFilters');
        if (saved) {
            try { return JSON.parse(saved); } catch (e) { }
        }
        return {
            selectedGroupFilter: '',
            selectedGroupName: '',
            selectedCategoryId: '',
            selectedStatus: 'ACTIVE',
            searchText: '',
        };
    };

    const initialFilters = getInitialMenuPricingFilters();

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const navigate = useNavigate();
    const accessToken = localStorage.getItem('authToken');
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [menuAccess, setMenuAccess] = useState([]);
    const [openedNewScreen, setOpenedNewScreen] = useState(false);
    const [groupByCategory, setGroupByCategory] = useState(true);
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: '6px',
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
            fontSize: '13px'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
            fontSize: '13px'
        }),
        menu: (provided) => ({
            ...provided,
            fontSize: '13px'
        }),
        option: (provided) => ({
            ...provided,
            fontSize: '13px'
        })
    };
    const animatedComponents = makeAnimated();

    const [bulkResult, setBulkResult] = useState(null);
    const [showResultModal, setShowResultModal] = useState(false);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("MenuPricing:")
            );
            setMenuAccess(filteredAccess);
        }
    }, [access]);

    console.log("Menu Access:", menuAccess);

    // States for Add functionality
    const [newPricing, setNewPricing] = useState({
        group: '',
        product: '',
        mrpPrice: '',
        offerPrice: '',
        isIntroductoryFlag: false
    });

    // States for Edit functionality
    const [editPricing, setEditPricing] = useState({
        _id: '',
        group: '',
        product: '',
        mrpPrice: '',
        offerPrice: '',
        isIntroductoryFlag: false
    });

    const [groups, setGroups] = useState([]);
    const [filteredProductList, setFilteredProductList] = useState([]);
    const [initialMenuPricings, setInitialMenuPricings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // Modal states
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showBulkModal, setShowBulkModal] = useState(false);

    const [selectedMarkupFilter, setSelectedMarkupFilter] = useState('ALL');
    const [markupSort, setMarkupSort] = useState('');
    const [showPriceModal, setShowPriceModal] = useState(false);
    const [selectedPricingItem, setSelectedPricingItem] = useState(null);
    const [newSellingPrice, setNewSellingPrice] = useState('');

    // State for bulk upload
    const [selectedGroup, setSelectedGroup] = useState('');
    // const [selectedGroupName, setSelectedGroupName] = useState('');
    const [selectedGroupName, setSelectedGroupName] = useState(initialFilters.selectedGroupName);
    const [file, setFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [menuPricings, setMenuPricings] = useState([]);
    const [proccessing, setProccessing] = useState(false);
    // const [selectedGroupFilter, setSelectedGroupFilter] = useState('');
    const [selectedGroupFilter, setSelectedGroupFilter] = useState(initialFilters.selectedGroupFilter);
    const [deleteGroupId, setDeleteGroupId] = useState('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    // const [searchText, setSearchText] = useState('');
    const [searchText, setSearchText] = useState(initialFilters.searchText);

    const [categoryList, setCategoryList] = useState([]);
    // const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [selectedCategoryId, setSelectedCategoryId] = useState(initialFilters.selectedCategoryId);

    // ✅ Status filter state - defaults to ACTIVE
    // const [selectedStatus, setSelectedStatus] = useState('ACTIVE');
    const [selectedStatus, setSelectedStatus] = useState(initialFilters.selectedStatus);

    const [excelBtnLoading, setExcelBtnLoading] = useState(false);
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);

    const [editingId, setEditingId] = useState(null);
    const [tempPricing, setTempPricing] = useState({
        mrpPrice: '',
        offerPrice: '',
        isIntroductoryFlag: false
    });

    const categoryOptions = categoryList.map((rm) => ({
        value: rm._id,
        label: rm.name,
    }));

    useEffect(() => {
        sessionStorage.setItem('menuPricingFilters', JSON.stringify({
            selectedGroupFilter,
            selectedGroupName,
            selectedCategoryId,
            selectedStatus,
            searchText,
        }));
    }, [selectedGroupFilter, selectedGroupName, selectedCategoryId, selectedStatus, searchText]);

    // Add these functions to your component
    const exportToPDF = () => {
        const doc = new jsPDF();

        // Add title
        doc.setFontSize(18);
        doc.text('Menu Pricing Report', 14, 20);

        // Get current date
        const date = new Date().toLocaleDateString();
        doc.setFontSize(10);
        doc.text(`Generated on: ${date}`, 14, 28);

        // Prepare data for the table
        const tableData = menuPricings?.map((item, index) => [
            index + 1,
            item?.group?.groupName,
            item?.group?._id,
            item?.product?.name,
            item?.product?._id,
            item?.product?.category?.name,
            item?.product?.foodType,
            `₹${item?.mrpPrice?.toFixed(2)}`,
            `₹${item?.offerPrice?.toFixed(2)}`,
            item?.isIntroductoryFlag ? 'Yes' : 'No'
        ]);

        // Add table
        doc.autoTable({
            head: [['#', 'Group', 'Product', 'Type', 'MRP Price', 'Offer Price', 'Category', 'Introductory']],
            body: tableData,
            startY: 35,
            styles: {
                fontSize: 8,
                cellPadding: 2,
            },
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: 255,
                fontStyle: 'bold'
            },
            columnStyles: {
                0: { cellWidth: 10 },
                1: { cellWidth: 30 },
                2: { cellWidth: 40 },
                3: { cellWidth: 20 },
                4: { cellWidth: 20 },
                5: { cellWidth: 20 },
                6: { cellWidth: 30 }
            }
        });

        // Save the PDF
        doc.save('menu_pricing_report.pdf');
    };

    const groupProductsByCategory = (products) => {
        if (!groupByCategory) return { 'All Products': products };

        return products.reduce((acc, item) => {
            const categoryName = item?.product?.category?.name || 'Uncategorized';
            if (!acc[categoryName]) {
                acc[categoryName] = [];
            }
            acc[categoryName].push(item);
            return acc;
        }, {});
    };

    const exportToExcel = (groupName = 'All Groups') => {
        setExcelBtnLoading(true);
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Menu Pricing');

        // Add main title (merged cells)
        worksheet.mergeCells('A1:H1');
        const titleRow = worksheet.getCell('A1');
        titleRow.value = `Menu Pricing Report - ${menuPricings[0]?.group?.groupName}`;
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };

        // Add subtitle with date (merged cells)
        worksheet.mergeCells('A2:H2');
        const dateRow = worksheet.getCell('A2');
        dateRow.value = `Generated on: ${new Date().toLocaleDateString()}`;
        dateRow.font = { italic: true, size: 10 };
        dateRow.alignment = { horizontal: 'center' };

        // Add headers
        const headers = ['#', 'Group', 'GroupId', 'Product', 'ProductId', 'Category', 'Type', 'MRP Price (₹)', 'Offer Price (₹)', 'Introduced Price'];
        const headerRow = worksheet.addRow(headers);

        // Style headers
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF2980B9' }
            };
            cell.font = {
                bold: true,
                color: { argb: 'FFFFFFFF' },
                size: 11
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
            cell.alignment = { horizontal: 'center' };
        });

        // Add data
        menuPricings?.forEach((item, index) => {
            const row = worksheet.addRow([
                index + 1,
                item?.group?.groupName || '-',
                item?.group?._id || '-',
                item?.product?.name || '-',
                item?.product?._id || '-',
                item?.product?.category?.name || '-',
                item?.product?.foodType || '-',
                Number(item?.mrpPrice?.toFixed(2)) || 0,
                Number(item?.offerPrice?.toFixed(2)) || 0,
                item?.isIntroductoryFlag ? 'Yes' : 'No'
            ]);

            // Style data rows
            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
                cell.font = { size: 10 };

                // Format price columns with ₹ symbol
                if (colNumber === 8 || colNumber === 9) {
                    cell.numFmt = '"₹"#,##0.00';
                }

                // Alternate row colors
                if (index % 2 === 0) {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF8F9FA' }
                    };
                }
            });
        });

        // Set column widths
        worksheet.columns = [
            { width: 5 },  // #
            { width: 20 }, // Group
            { width: 30 }, // GroupId
            { width: 30 }, // Product
            { width: 40 }, // ProductId
            { width: 20 }, // Category
            { width: 15 }, // Type
            { width: 15 }, // MRP Price
            { width: 15 }, // Offer Price
            { width: 15 }  // Introductory
        ];

        // Generate and download Excel file
        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `menu_pricing_report_.xlsx`;
            link.click();
        });
        setExcelBtnLoading(false);
    };

    const handleDownloadExcel = async () => {
        setDownloadBtnLoading(true);

        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Product Pricing');

            worksheet.views = [
                { state: 'frozen', ySplit: 4 }
            ];

            const currentData = getFilteredMenuPricings();
            const groupedData = groupProductsByCategory(currentData);

            worksheet.mergeCells('A1:K1');
            worksheet.getCell('A1').value =
                `Product Pricing Report - ${selectedGroupName}`;

            worksheet.getCell('A1').font = {
                bold: true,
                size: 16
            };

            worksheet.mergeCells('A2:K2');
            worksheet.getCell('A2').value =
                `Generated On : ${new Date().toLocaleString()}`;

            let rowNo = 4;

            Object.entries(groupedData).forEach(([category, items]) => {

                worksheet.mergeCells(`A${rowNo}:K${rowNo}`);

                const catCell = worksheet.getCell(`A${rowNo}`);
                catCell.value = `${category} (${items.length} Products)`;

                catCell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF4F46E5' }
                };

                catCell.font = {
                    bold: true,
                    color: { argb: 'FFFFFFFF' }
                };

                rowNo++;

                const headerRow = worksheet.getRow(rowNo);

                headerRow.values = [
                    'Sr No',
                    'Product',
                    'Category',
                    'Costing',
                    '2x',
                    '3x',
                    '4x',
                    '5x',
                    '6x',
                    'Selling Price',
                    'Markup'
                ];

                headerRow.eachCell(cell => {
                    cell.font = {
                        bold: true,
                        color: { argb: 'FFFFFFFF' }
                    };

                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FF2980B9' }
                    };
                });

                rowNo++;

                items.forEach((item, index) => {

                    const cost =
                        Number(item?.product?.productCost || 0);

                    const selling =
                        Number(item?.offerPrice || 0);

                    const markup =
                        cost > 0
                            ? (selling / cost).toFixed(1)
                            : '0.0';

                    worksheet.addRow([
                        index + 1,
                        item?.product?.name,
                        item?.product?.category?.name,
                        cost,
                        cost * 2,
                        cost * 3,
                        cost * 4,
                        cost * 5,
                        cost * 6,
                        selling,
                        `${markup}x`
                    ]);
                });

                rowNo = worksheet.rowCount + 2;
            });

            worksheet.columns = [
                { width: 8 },
                { width: 35 },
                { width: 25 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
                { width: 18 },
                { width: 12 }
            ];

            const buffer = await workbook.xlsx.writeBuffer();

            const blob = new Blob(
                [buffer],
                {
                    type:
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
            );

            const link = document.createElement('a');

            link.href = URL.createObjectURL(blob);

            link.download =
                `Product_Pricing_${selectedGroupName}.xlsx`;

            link.click();
        }
        finally {
            setDownloadBtnLoading(false);
        }
    };

    // ✅ Updated getMenuPricings - accepts status param, defaults to 'ACTIVE'
    const getMenuPricings = async (id, catId, download, status = 'ACTIVE') => {
        setProccessing(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            let params = `menu-product-pricing?group=${id}`;

            if (catId && catId !== "all") {
                params += `&categoryId=${catId}`;
            }

            // ✅ Append status to params
            if (status) {
                params += `&status=${status}`;
            }

            if (download) {
                params += `&isDownload=${download}`;
            }

            const response = await axios.get(params, {
                headers,
                responseType: download ? "blob" : "json"
            });

            if (download) {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                const url = window.URL.createObjectURL(blob);
                console.log("Download Url Log :", url);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Menu Pricing Of the Group ${selectedGroupName}.xlsx`);
                document.body.appendChild(link);
                link.click();

                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);

                toast.success('Excel file downloaded successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light"
                });
            } else {
                console.log("Menu Pricing List :", response?.data?.data?.menuGroup);
                let FilteredPricing = response?.data?.data?.menuGroup?.filter(mp => mp.product?.isDelete === false);
                console.log("Filtered Pricing List :", FilteredPricing);
                // setInitialMenuPricings(FilteredPricing);
                // setMenuPricings(FilteredPricing);
                setInitialMenuPricings(FilteredPricing);
                // Re-apply any active search text after data loads
                const savedSearch = sessionStorage.getItem('menuPricingFilters');
                const parsedSearch = savedSearch ? JSON.parse(savedSearch)?.searchText : '';
                if (parsedSearch) {
                    setMenuPricings(FilteredPricing.filter(item =>
                        item?.product?.name?.toLowerCase().includes(parsedSearch.toLowerCase())
                    ));
                } else {
                    setMenuPricings(FilteredPricing);
                }
            }
        } catch (error) {
            console.log("Error in Menu Pricing Api:", error);
        } finally {
            setProccessing(false);
            setDownloadBtnLoading(false);
        }
    };

    const getCategoryList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                setCategoryList(response?.data?.data?.categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getProductsList = async (id) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product", { headers });
            if (response?.data?.status === true) {
                let filterPro = response?.data?.data?.products;
                setFilteredProductList(filterPro);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getMenuGroup = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("menu-group", { headers });
            if (response?.data?.status === true) {
                setGroups(response?.data?.data?.menuGroup);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleCloseAddModal = () => {
        setShowAddModal(false);
        setNewPricing({
            group: '',
            product: '',
            mrpPrice: '',
            offerPrice: '',
            isIntroductoryFlag: false
        });
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setEditPricing({
            _id: '',
            group: '',
            product: '',
            mrpPrice: '',
            offerPrice: '',
            isIntroductoryFlag: false
        });
    };

    const handleCloseBulkModal = () => {
        setShowBulkModal(false);
        setSelectedGroup('');
        setFile(null);
    }

    const handleAddInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewPricing(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleEditInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEditPricing(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setSuccessMessage('');
        setErrorMessage('');

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const response = await axios.post('menu-product-pricing?_single=true', newPricing, { headers });

            toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });

            setNewPricing({
                group: '',
                product: '',
                mrpPrice: '',
                offerPrice: '',
                isIntroductoryFlag: false
            });
            getMenuPricings(selectedGroupFilter, selectedCategoryId, false, selectedStatus);
            setShowAddModal(false);
        } catch (error) {
            console.log("HEllo", error);
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setSuccessMessage('');
        setErrorMessage('');

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const response = await axios.put(
                `menu-product-pricing?_single=true&_id=${editPricing._id}`,
                editPricing,
                { headers }
            );

            toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
            getMenuPricings(selectedGroupFilter, selectedCategoryId, false, selectedStatus);
            setEditPricing({
                _id: '',
                group: '',
                product: '',
                mrpPrice: '',
                offerPrice: '',
                isIntroductoryFlag: false
            });
            setShowEditModal(false);
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleApiError = (error) => {
        console.log("Error :", error);

        if (error?.response) {
            let errorMessage = '';
            if (error.response?.status === 406) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
            }
            else if (error.response?.status === 412) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 400) {
                errorMessage = error?.response?.data?.message || error?.response?.data?.error;
            } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error;
            } else if (error?.response?.status === 404) {
                errorMessage = error?.response?.data?.error;
            }

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    // Bulk upload functions
    const { getRootProps, getInputProps } = useDropzone({
        accept: '.xlsx, .xls',
        maxFiles: 1,
        onDrop: acceptedFiles => {
            setFile(acceptedFiles[0]);
        }
    });

    const handleBulkSubmit = async () => {
        if (!file) {
            setErrorMessage('Please select a group and upload a file');
            return;
        }

        setUploading(true);
        setErrorMessage('');

        const formData = new FormData();
        formData.append('file', file);

        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
            };

            const response = await axios.put('menu-product-pricing/bulkprice', formData,
                {
                    headers,
                    onUploadProgress: progressEvent => {
                        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(progress);
                    }
                }
            );

            console.log("Response :", response);

            const data = response?.data;

            if (data?.errors?.length || data?.duplicates?.length || data?.skippedCount > 0) {
                setBulkResult(data);
                setShowResultModal(true);
            } else {
                toast.success(data?.message || "Bulk update completed.", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }

            setFile(null);
            setSelectedGroup('');
            getMenuPricings(selectedGroupFilter, selectedCategoryId, false, selectedStatus);
            setShowBulkModal(false);

        } catch (error) {
            console.log("Error in bulk price update :", error);
            handleApiError(error);
        } finally {
            setUploading(false);
            setUploadProgress(0);
        }
    };

    // ✅ Group filter change - resets category, search, status to defaults
    const handleSelectedGroupFilterChange = (e) => {
        const pricingID = e.target.value;
        const groupLabel = e.target.selectedOptions[0].label;

        setSelectedGroupFilter(pricingID);
        setSelectedGroupName(groupLabel);

        // ✅ Reset dependent filters when group changes (no useEffect needed)
        if (!pricingID) {
            setSearchText('');
            setSelectedCategoryId('');
            setSelectedStatus('ACTIVE');
            setMenuPricings([]);
            setInitialMenuPricings([]);
            return;
        }

        // Fetch with current category & status (or reset to defaults)
        getMenuPricings(pricingID, selectedCategoryId, false, selectedStatus);
    };

    // ✅ Category filter change handler
    const handleSelectedCategoryFilterChange = (selectedOption) => {
        const catId = selectedOption ? selectedOption.value : 'all';
        setSelectedCategoryId(catId);
        getMenuPricings(selectedGroupFilter, catId, false, selectedStatus);
    };

    // ✅ Status filter change handler
    const handleStatusFilterChange = (e) => {
        const status = e.target.value;
        setSelectedStatus(status);
        getMenuPricings(selectedGroupFilter, selectedCategoryId, false, status);
    };

    // ✅ Search change handler (replaces useEffect for search)
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchText(value);

        if (!value.trim()) {
            setMenuPricings(initialMenuPricings);
            return;
        }

        const result = initialMenuPricings?.filter((item) =>
            item?.product?.name?.toLowerCase().includes(value.toLowerCase())
        );
        setMenuPricings(result);
    };

    const handleView = (item) => {
        console.log("Viewing:", item);
        setOpenedNewScreen(true);
        let menuPricingScreen = 'product-detail-report'
        navigate(`/reports/product-detail-report/${item?.product?._id}/${item?.product?.name}/${menuPricingScreen}`);
    };

    const handleOpenDeleteModal = (data) => {
        console.log("Data to be deleted :", data);
        setDeleteGroupId(data?._id);
        setOpenDeleteModal(true);
    };

    const handleDelete = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: deleteGroupId,
            };

            const response = await axios.delete(`menu-product-pricing`, { data, headers });
            console.log("Response :", response);
            getMenuPricings(selectedGroupFilter, selectedCategoryId, false, selectedStatus);
            toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
            setOpenDeleteModal(false);
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response.status === 404) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response.status === 406) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response.status === 412) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handleUpdatePricing = async (item, updatedOfferPrice) => {
        setIsLoading(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            const payload = {
                _id: item._id,
                group: item?.group?._id,
                product: item?.product?._id,
                mrpPrice: item?.mrpPrice,
                offerPrice: Number(updatedOfferPrice),
                isIntroductoryFlag: item?.isIntroductoryFlag || false
            };

            const response = await axios.put(
                `menu-product-pricing?_single=true&_id=${item._id}`,
                payload,
                { headers }
            );

            toast.success(response?.data?.data?.message || "Price updated successfully", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });

            setShowPriceModal(false);
            setSelectedPricingItem(null);
            setNewSellingPrice('');

            getMenuPricings(selectedGroupFilter, selectedCategoryId, false, selectedStatus);

        } catch (error) {
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const getFilteredMenuPricings = () => {
        let data = [...menuPricings];

        // Markup Filter
        if (selectedMarkupFilter !== 'ALL') {
            data = data.filter(item => {
                const cost = Number(item?.product?.productCost || 0);
                const selling = Number(item?.offerPrice || 0);

                const markup = cost > 0
                    ? selling / cost
                    : 0;

                switch (selectedMarkupFilter) {
                    case 'LT2':
                        return markup < 2;

                    case '2TO3':
                        return markup >= 2 && markup < 3;

                    case '3TO4':
                        return markup >= 3 && markup < 4;

                    case '4TO5':
                        return markup >= 4 && markup < 5;

                    case '5TO6':
                        return markup >= 5 && markup < 6;

                    case 'GT6':
                        return markup >= 6;

                    default:
                        return true;
                }
            });
        }

        // Sort
        if (markupSort) {
            data.sort((a, b) => {
                const markupA =
                    Number(a?.offerPrice || 0) /
                    Number(a?.product?.productCost || 1);

                const markupB =
                    Number(b?.offerPrice || 0) /
                    Number(b?.product?.productCost || 1);

                return markupSort === 'HIGH_TO_LOW'
                    ? markupB - markupA
                    : markupA - markupB;
            });
        }

        return data;
    };

    const openPriceUpdateModal = (item) => {
        setSelectedPricingItem(item);
        setNewSellingPrice(item?.offerPrice || '');
        setShowPriceModal(true);
    };

    const getPriceComparison = () => {
        const cost = Number(selectedPricingItem?.product?.productCost || 0);
        const currentPrice = Number(selectedPricingItem?.offerPrice || 0);
        const newPrice = Number(newSellingPrice || 0);

        const currentMarkup = cost > 0 ? currentPrice / cost : 0;
        const newMarkup = cost > 0 ? newPrice / cost : 0;

        const currentMargin = currentPrice > 0
            ? ((currentPrice - cost) / currentPrice) * 100
            : 0;

        const newMargin = newPrice > 0
            ? ((newPrice - cost) / newPrice) * 100
            : 0;

        const priceChangePercent = currentPrice > 0
            ? ((newPrice - currentPrice) / currentPrice) * 100
            : 0;

        return {
            cost,
            currentMarkup,
            newMarkup,
            currentMargin,
            newMargin,
            priceChangePercent
        };
    };

    // AFTER
    useEffect(() => {
        getProductsList();
        getMenuGroup();
        getCategoryList();
        if (initialFilters.selectedGroupFilter) {
            getMenuPricings(
                initialFilters.selectedGroupFilter,
                initialFilters.selectedCategoryId,
                false,
                initialFilters.selectedStatus
            );
        }
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold" style={{ fontSize: "18px" }}>PRODUCT PRICING REPORT</h5>
                        </Col>
                        <hr />
                    </Row>

                    {/* Filter Row */}
                    <Row className='align-items-end g-3'>

                        {/* Group Filter */}
                        <Col md={3} lg={3}>
                            <Form.Label className='text-muted fw-semibold mb-1' style={{ fontSize: "12px" }}>
                                Menu Group
                            </Form.Label>
                            <Select
                                options={groups.map(group => ({
                                    value: group._id,
                                    label: group.groupName
                                }))}
                                value={
                                    groups.find(g => g._id === selectedGroupFilter)
                                        ? { value: selectedGroupFilter, label: groups.find(g => g._id === selectedGroupFilter)?.groupName }
                                        : null
                                }
                                onChange={(selectedOption) => {
                                    handleSelectedGroupFilterChange({
                                        target: {
                                            value: selectedOption ? selectedOption.value : '',
                                            selectedOptions: [{ label: selectedOption ? selectedOption.label : '' }]
                                        }
                                    });
                                }}
                                placeholder="Select Menu Group"
                                styles={customStyles}
                                isClearable
                            />
                        </Col>

                        {/* Category Filter */}
                        <Col md={2} lg={3}>
                            <Form.Label className='text-muted fw-semibold mb-1' style={{ fontSize: "12px" }}>
                                Category
                            </Form.Label>
                            <Select
                                name="categoryFilter"
                                options={categoryOptions}
                                value={categoryOptions.find((opt) => opt.value === selectedCategoryId) || null}
                                onChange={(selectedOption) => handleSelectedCategoryFilterChange(selectedOption)}
                                isDisabled={!selectedGroupFilter}
                                placeholder="All Categories"
                                styles={customStyles}
                                isClearable
                            />
                        </Col>

                        {/* Status Filter */}
                        <Col md={2} lg={3}>
                            <Form.Label className='text-muted fw-semibold mb-1' style={{ fontSize: "12px" }}>
                                Status
                            </Form.Label>
                            <Select
                                options={[
                                    { value: 'ACTIVE', label: 'Active' },
                                    { value: 'INACTIVE', label: 'Inactive' }
                                ]}
                                value={
                                    selectedStatus
                                        ? { value: selectedStatus, label: selectedStatus === 'ACTIVE' ? 'Active' : 'Inactive' }
                                        : null
                                }
                                onChange={(selectedOption) => handleStatusFilterChange({
                                    target: { value: selectedOption ? selectedOption.value : 'ACTIVE' }
                                })}
                                isDisabled={!selectedGroupFilter}
                                placeholder="Select Status"
                                styles={customStyles}
                                isClearable={false}
                            />
                        </Col>

                        {/* Search */}
                        <Col md={3} lg={3}>
                            <Form.Label className='text-muted fw-semibold mb-1' style={{ fontSize: "12px" }}>
                                Search Product
                            </Form.Label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search for products..."
                                    value={searchText}
                                    disabled={!selectedGroupFilter}
                                    onChange={handleSearchChange}
                                    style={{ fontSize: "13px" }}
                                />
                                <button
                                    className="btn btn-primary btn-sm"
                                    type="button"
                                    style={{ fontSize: "13px", padding: "0.25rem 0.6rem", zIndex: 0 }}
                                >
                                    <i className="ri-search-line"></i>
                                </button>
                            </div>
                        </Col>

                        <Col md={2} lg={2}>
                            <Form.Label
                                className='text-muted fw-semibold mb-1'
                                style={{ fontSize: "12px" }}
                            >
                                Markup Filter
                            </Form.Label>

                            <Select
                                options={[
                                    { value: 'ALL', label: 'All' },
                                    { value: 'LT2', label: '< 2x' },
                                    { value: '2TO3', label: '2x - 3x' },
                                    { value: '3TO4', label: '3x - 4x' },
                                    { value: '4TO5', label: '4x - 5x' },
                                    { value: '5TO6', label: '5x - 6x' },
                                    { value: 'GT6', label: '> 6x' }
                                ]}
                                value={{
                                    value: selectedMarkupFilter,
                                    label: selectedMarkupFilter
                                }}
                                onChange={(option) =>
                                    setSelectedMarkupFilter(option?.value || 'ALL')
                                }
                                styles={customStyles}
                            />
                        </Col>

                        <Col md={2} lg={2}>
                            <Form.Label
                                className='text-muted fw-semibold mb-1'
                                style={{ fontSize: "12px" }}
                            >
                                Sort By
                            </Form.Label>

                            <Select
                                options={[
                                    { value: '', label: 'Default' },
                                    { value: 'HIGH_TO_LOW', label: 'Markup High → Low' },
                                    { value: 'LOW_TO_HIGH', label: 'Markup Low → High' }
                                ]}
                                onChange={(option) =>
                                    setMarkupSort(option?.value || '')
                                }
                                styles={customStyles}
                            />
                        </Col>

                    </Row>

                    <Row className="mt-4 mb-2">
                        <Col>
                            <Card className="shadow-sm mb-4">
                                <Card.Header className="bg-white">
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div>
                                            <h5 className="mb-0 fw-semibold" style={{ fontSize: "16px" }}>Pricing List</h5>
                                        </div>
                                        <div>
                                            <Button
                                                variant="outline-success"
                                                size="sm"
                                                onClick={handleDownloadExcel}
                                                className="me-2"
                                                disabled={!selectedGroupFilter || menuPricings.length === 0 || downloadBtnLoading}
                                                style={{ fontSize: "12px", padding: "0.25rem 0.5rem" }}
                                            >
                                                <i className="ri-file-excel-2-line me-1"></i>
                                                {downloadBtnLoading ? <Spinner size='sm' /> : 'Export to Excel'}
                                            </Button>
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    {proccessing ? (
                                        <div className="text-center py-4">
                                            <Spinner animation="border" variant="primary" />
                                        </div>
                                    ) : (
                                        <>
                                            <div className="table-responsive">
                                                {(menuAccess.includes("MenuPricing:get") || email === "contact@xpansecafe.com") && (
                                                    <>
                                                        {!selectedGroupFilter ? (
                                                            <table className="table table-hover table-sm">
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan="9" className="text-center py-4">
                                                                            <div className="d-flex flex-column align-items-center">
                                                                                <i className="ri-information-line fs-1 text-muted mb-2"></i>
                                                                                <h5 className="text-muted" style={{ fontSize: "14px" }}>Please select a group to see product pricings</h5>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        ) : menuPricings?.length === 0 ? (
                                                            <table className="table table-hover table-sm">
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan="9" className="text-center py-4">
                                                                            <div className="d-flex flex-column align-items-center">
                                                                                <i className="ri-database-2-line fs-1 text-muted mb-2"></i>
                                                                                <h5 className="text-muted" style={{ fontSize: "14px" }}>No pricing data found</h5>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        ) : (
                                                            Object.entries(groupProductsByCategory(getFilteredMenuPricings())).map(([categoryName, items], categoryIndex) => (
                                                                <div key={categoryIndex} className="mb-4">
                                                                    {groupByCategory && (
                                                                        <div
                                                                            className="px-2 py-1 mb-3 rounded-1 d-flex justify-content-between align-items-center shadow-sm"
                                                                            style={{
                                                                                background: "linear-gradient(135deg, #4f46e5, #6366f1)",
                                                                                border: "1px solid rgba(255,255,255,0.15)",
                                                                            }}
                                                                        >
                                                                            <h6
                                                                                className="mb-0 fw-bold d-flex align-items-center"
                                                                                style={{
                                                                                    fontSize: "14px",
                                                                                    color: "#fff",
                                                                                    letterSpacing: "0.3px",
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className="ri-folder-line me-2"
                                                                                    style={{
                                                                                        fontSize: "18px",
                                                                                        color: "#c7d2fe",
                                                                                    }}
                                                                                ></i>
                                                                                {categoryName}
                                                                            </h6>

                                                                            <span
                                                                                className="badge rounded-3 px-3 py-2"
                                                                                style={{
                                                                                    background: "rgba(255,255,255,0.18)",
                                                                                    color: "#fff",
                                                                                    backdropFilter: "blur(4px)",
                                                                                    fontSize: "11px",
                                                                                    fontWeight: "600",
                                                                                    border: "1px solid rgba(255,255,255,0.2)",
                                                                                }}
                                                                            >
                                                                                {items.length} {items.length === 1 ? "item" : "items"}
                                                                            </span>
                                                                        </div>
                                                                    )}

                                                                    <table className="table table-hover table-sm mb-0">
                                                                        <thead>
                                                                            <tr style={{ fontSize: "13px" }}>
                                                                                <th>Sr.no</th>
                                                                                <th>Product</th>
                                                                                <th className='text-center'>Costing</th>
                                                                                <th className='text-center'>2x</th>
                                                                                <th className='text-center'>3x</th>
                                                                                <th className='text-center'>4x</th>
                                                                                <th className='text-center'>5x</th>
                                                                                <th className='text-center'>6x</th>
                                                                                <th className='text-center'>Selling Price</th>
                                                                                <th className='text-center'>Markup</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody style={{ fontSize: "12px" }}>
                                                                            {items.map((item, index) => {
                                                                                const cost = Number(item?.product?.productCost || 0);
                                                                                const selling = Number(item?.offerPrice || 0);

                                                                                const markup = cost > 0
                                                                                    ? (selling / cost).toFixed(1)
                                                                                    : "0.0";

                                                                                const margin = selling > 0
                                                                                    ? (((selling - cost) / selling) * 100).toFixed(1)
                                                                                    : "0.0";

                                                                                return (
                                                                                    <tr key={item._id}>
                                                                                        <td style={{ fontSize: "12px", cursor: "pointer" }} onClick={() => handleView(item)}>
                                                                                            {groupByCategory ? index + 1 : menuPricings.indexOf(item) + 1}
                                                                                        </td>
                                                                                        <td style={{ fontSize: "12px", cursor: "pointer" }} onClick={() => handleView(item)}>
                                                                                            <div className='d-flex align-items-center gap-2'>
                                                                                                <div>
                                                                                                    <img
                                                                                                        src={item?.product?.displayImage}
                                                                                                        alt={item?.product?.name}
                                                                                                        style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
                                                                                                    />
                                                                                                </div>
                                                                                                <div>
                                                                                                    <div className='fw-semibold'>{item?.product?.name}</div>
                                                                                                    <div className="text-muted small" style={{ fontSize: "11px" }}>{item?.product?.category?.name}</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>

                                                                                        <td
                                                                                            className='text-center'
                                                                                            style={{ fontSize: "12px", cursor: "pointer" }}
                                                                                            onClick={() => handleView(item)}
                                                                                        >
                                                                                            ₹{Number(item?.product?.productCost || 0).toFixed(2)}
                                                                                        </td>

                                                                                        <td className='text-center' style={{ backgroundColor: '#D6EAF8' }}>
                                                                                            ₹{(Number(item?.product?.productCost || 0) * 2).toFixed(2)}
                                                                                        </td>

                                                                                        <td className='text-center' style={{ backgroundColor: '#D5F5E3' }}>
                                                                                            ₹{(Number(item?.product?.productCost || 0) * 3).toFixed(2)}
                                                                                        </td>

                                                                                        <td className='text-center' style={{ backgroundColor: '#FCF3CF' }}>
                                                                                            ₹{(Number(item?.product?.productCost || 0) * 4).toFixed(2)}
                                                                                        </td>

                                                                                        <td className='text-center' style={{ backgroundColor: '#E8DAEF' }}>
                                                                                            ₹{(Number(item?.product?.productCost || 0) * 5).toFixed(2)}
                                                                                        </td>

                                                                                        <td className='text-center' style={{ backgroundColor: '#FADBD8' }}>
                                                                                            ₹{(Number(item?.product?.productCost || 0) * 6).toFixed(2)}
                                                                                        </td>

                                                                                        {/* <td className='text-center' style={{ fontSize: "12px" }}>
                                                                                            {editingId === item._id ? (
                                                                                                <Form.Control
                                                                                                    type="number"
                                                                                                    min={0}
                                                                                                    value={tempPricing.offerPrice}
                                                                                                    onChange={(e) => setTempPricing({ ...tempPricing, offerPrice: e.target.value })}
                                                                                                    className="w-100"
                                                                                                    disabled={item?.product?.isFreebieProduct}
                                                                                                    style={{ fontSize: "12px", padding: "0.25rem 0.5rem", height: "auto" }}
                                                                                                />
                                                                                            ) : (
                                                                                                <span className="text-success fw-bold">₹{item?.offerPrice}</span>
                                                                                            )}
                                                                                        </td> */}

                                                                                        <td className='text-center' style={{ fontSize: "12px" }}>
                                                                                            <span
                                                                                                className="text-success fw-bold"
                                                                                                style={{
                                                                                                    cursor: "pointer",
                                                                                                    borderBottom: "1px dashed #198754"
                                                                                                }}
                                                                                                title="Click to update price"
                                                                                                onClick={() => openPriceUpdateModal(item)}
                                                                                            >
                                                                                                ₹{item?.offerPrice}
                                                                                            </span>
                                                                                        </td>

                                                                                        <td
                                                                                            className='text-center fw-bold'
                                                                                            style={{
                                                                                                backgroundColor:
                                                                                                    markup >= 6
                                                                                                        ? '#FADBD8'   // Red (6x+)
                                                                                                        : markup >= 5
                                                                                                            ? '#E8DAEF' // Purple (5x+)
                                                                                                            : markup >= 4
                                                                                                                ? '#FCF3CF' // Yellow (4x+)
                                                                                                                : markup >= 3
                                                                                                                    ? '#D5F5E3' // Green (3x+)
                                                                                                                    : '#D6EAF8', // Blue (<3x)
                                                                                                color: '#333'
                                                                                            }}
                                                                                        >
                                                                                            {markup}x
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            ))
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>

                {successMessage && (
                    <Alert variant="success" onClose={() => setSuccessMessage('')} dismissible style={{ fontSize: "13px" }}>
                        {successMessage}
                    </Alert>
                )}

                {errorMessage && (
                    <Alert variant="danger" onClose={() => setErrorMessage('')} dismissible style={{ fontSize: "13px" }}>
                        {errorMessage}
                    </Alert>
                )}

            </div>

            <Modal
                show={showPriceModal}
                onHide={() => setShowPriceModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: "16px" }}>
                        Update Selling Price
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="mb-3">
                        <div className="fw-semibold">
                            {selectedPricingItem?.product?.name}
                        </div>
                        <div className="text-muted small">
                            {selectedPricingItem?.product?.category?.name}
                        </div>
                    </div>

                    <Row>
                        <Col md={6}>
                            <Form.Label className="text-muted small">
                                Current Price
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={`₹${selectedPricingItem?.offerPrice || 0}`}
                                disabled
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Label className="text-muted small">
                                New Price
                            </Form.Label>
                            <Form.Control
                                autoFocus
                                type="number"
                                min={0}
                                value={newSellingPrice}
                                onChange={(e) => setNewSellingPrice(e.target.value)}
                                placeholder="Enter new price"
                            />
                        </Col>
                    </Row>
                    {selectedPricingItem && newSellingPrice !== '' && (
                        <div className="mt-3 p-3 rounded-2 border bg-light">
                            <div className="fw-semibold mb-2" style={{ fontSize: "13px" }}>
                                Price Impact
                            </div>

                            <Row className="g-2">
                                <Col md={4}>
                                    <div className="small text-muted">Cost</div>
                                    <div className="fw-bold">
                                        ₹{getPriceComparison().cost.toFixed(2)}
                                    </div>
                                </Col>

                                <Col md={4}>
                                    <div className="small text-muted">Current Markup</div>
                                    <div className="fw-bold text-secondary">
                                        {getPriceComparison().currentMarkup.toFixed(1)}x
                                    </div>
                                </Col>

                                <Col md={4}>
                                    <div className="small text-muted">New Markup</div>
                                    <div className="fw-bold text-primary">
                                        {getPriceComparison().newMarkup.toFixed(1)}x
                                    </div>
                                </Col>

                                <Col md={4}>
                                    <div className="small text-muted">Current Margin</div>
                                    <div className="fw-bold text-secondary">
                                        {getPriceComparison().currentMargin.toFixed(1)}%
                                    </div>
                                </Col>

                                <Col md={4}>
                                    <div className="small text-muted">New Margin</div>
                                    <div className="fw-bold text-primary">
                                        {getPriceComparison().newMargin.toFixed(1)}%
                                    </div>
                                </Col>

                                <Col md={4}>
                                    <div className="small text-muted">Price Change</div>
                                    <div
                                        className={`fw-bold ${getPriceComparison().priceChangePercent >= 0
                                            ? 'text-success'
                                            : 'text-danger'
                                            }`}
                                    >
                                        {getPriceComparison().priceChangePercent >= 0 ? '+' : ''}
                                        {getPriceComparison().priceChangePercent.toFixed(1)}%
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => setShowPriceModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="primary"
                        size="sm"
                        disabled={
                            isLoading ||
                            newSellingPrice === '' ||
                            Number(newSellingPrice) < 0
                        }
                        onClick={() => {
                            if (!selectedPricingItem) return;

                            handleUpdatePricing(selectedPricingItem, newSellingPrice);
                        }}
                    >
                        {isLoading ? <Spinner size="sm" /> : 'Save Price'}
                    </Button>
                </Modal.Footer>
            </Modal>

        </React.Fragment>
    );
};

export default ProductCostingReport;